import React, { useEffect, useState } from 'react';
import { Translate } from 'react-redux-i18n';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../hooks';
import { RootState } from '../../../store';
import { getCampaignOrganizer } from '../../campaignOrganizers/store/campaignOrganizerActions';
import CampaignOrganizerInput from '../../campaignOrganizers/input/CampaignOrganizerInput';
import Spinner from '../../../components/common/spinner';

const EditCampaignOrganizerContent = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const [loaded, setLoaded] = useState(false);
  const state = useSelector((s: RootState) => (s as any).campaignOrganizer);

  useEffect(() => {
    if (id) dispatch(getCampaignOrganizer(Number(id)) as any);
  }, [id, dispatch]);

  useEffect(() => {
    if (state?.recordEdit?.ready === 0 && state?.recordEdit?.data) {
      setLoaded(true);
    }
  }, [state?.recordEdit]);

  if (!loaded) return <Spinner />;

  return (
    <>
      <h2>
        <Translate value='campaignOrganizers.page.edit.title' />
      </h2>
      <CampaignOrganizerInput mode='edit' initialValue={state?.recordEdit?.data} />
    </>
  );
};

export default EditCampaignOrganizerContent;
